import { ReactElement } from 'react'
import styled from 'styled-components'
import { VehicleSpecificationItem } from '../../../../../../../src/store/models/VehicleSpecification'
import { Translate, Translate2 } from 'common'
import { SectionTitle, ReceiptTableGrid, ReceiptCell } from '../printStyles'

interface Props {
  specifications: VehicleSpecificationItem[]
}

const Specifications = (props: Props): ReactElement | null => {
  const { specifications } = props

  if (!specifications?.length) {
    return null
  }

  return (
    <>
      <SectionTitle>{Translate2('specifications')}</SectionTitle>
      <ReceiptTableGrid $columns="1fr 2fr">
        <ReceiptCell $header $align="start">
          {Translate2('description')}
        </ReceiptCell>
        <ReceiptCell $header $align="start">
          {Translate2('details')}
        </ReceiptCell>

        {specifications.map((specification) => (
          <SpecRow key={specification.partNumber}>
            <ReceiptCell $align="start">
              {specification.description}
            </ReceiptCell>
            <ReceiptCell $align="start">
              {specification.extendedDescription}
              {specification.partNumber && ` ${specification.partNumber}`}
              {specification.years &&
                `, ${Translate('years')}: ${specification.years}`}
              {specification.miscellaneousTexts?.map((text, index) => (
                <span key={index}>{text} </span>
              ))}
            </ReceiptCell>
          </SpecRow>
        ))}
      </ReceiptTableGrid>
    </>
  )
}

const SpecRow = styled.div`
  display: contents;
`

export default Specifications
